import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {
  AccessPage,
  BurningRulesIndexPage,
  CurrenciesIndexPage,
  EarningRulesIndexPage,
  EditorPage,
  LevelsIndexPage,
  ProfilesIndexPage,
  ProgramSettingsPage,
  ReferralPage,
  RewardsIndexPage,
} from './pages';
import { CurrenciesProvider } from './libs/currency/CurrenciesContext';
import { IncomingWebhooksIndexPage } from './pages/incoming-webhooks';
import { LevelConfigProvider } from './libs/levels/LevelsConfigContext';
import { LevelsProvider } from './libs/levels/LevelsContext';
import { LoginPage } from './pages/program-login';
import { LoyaltyTopbar } from './libs/shared/topbar';
import { Page, PageBody, PageHeader } from './libs/shared/page';
import { ProgramProvider, useProgram } from './libs/loyalty/ProgramContext';
import { QlfPageErrorBoundary } from './libs/shared/QlfPageErrorBoundary';
import { ReferralConfigProvider } from './libs/referral/ReferralConfigContext';
import { ReportIndexPage } from './pages/report';
import { RewardsProvider } from './libs/rewards/RewardsContext';
import { RulesProvider } from './libs/rules/RulesContext';
import { TopBar } from './libs/shared/layout/TopBar';

export const programRoutes = [
  {
    name: 'loyaltyProgram',
    path: '/accounts/:accountId/programs/:id',
    component: Home,
  },
  {
    name: 'earningRules',
    path: '/accounts/:accountId/programs/:id/earning-rules',
    component: EarningRulesIndexPage,
  },
  {
    name: 'burningRules',
    path: '/accounts/:accountId/programs/:id/burning-rules',
    component: BurningRulesIndexPage,
  },
  {
    name: 'rewards',
    path: '/accounts/:accountId/programs/:id/rewards',
    component: RewardsIndexPage,
  },
  {
    name: 'rewardsUniqueCodes',
    path: '/accounts/:accountId/programs/:id/rewards/promo-codes',
    component: RewardsIndexPage,
  },
  {
    name: 'levels',
    path: '/accounts/:accountId/programs/:id/settings/levels',
    component: LevelsIndexPage,
  },
  {
    name: 'editor',
    path: '/accounts/:accountId/programs/:id/editor',
    component: EditorPage,
  },
  {
    name: 'currencies',
    path: '/accounts/:accountId/programs/:id/settings/currencies',
    component: CurrenciesIndexPage,
  },
  {
    name: 'profiles',
    path: '/accounts/:accountId/programs/:id/profiles',
    component: ProfilesIndexPage,
  },
  {
    name: 'incoming-webhooks',
    path: '/accounts/:accountId/programs/:id/settings/incoming-webhooks',
    component: IncomingWebhooksIndexPage,
  },
  {
    name: 'report',
    path: '/accounts/:accountId/programs/:id/report',
    component: ReportIndexPage,
  },
  {
    name: 'referral',
    path: '/accounts/:accountId/programs/:id/settings/referral',
    component: ReferralPage,
  },
  {
    name: 'access',
    path: '/accounts/:accountId/programs/:id/settings/access',
    component: AccessPage,
  },
  {
    name: 'login',
    path: '/accounts/:accountId/programs/:id/settings/login',
    component: LoginPage,
  },
  {
    name: 'settings',
    path: '/accounts/:accountId/programs/:id/settings',
    component: ProgramSettingsPage,
  },
];

export function ProgramRoutes() {
  return (
    <ProgramProvider>
      <ReferralConfigProvider>
        <CurrenciesProvider>
          <LevelConfigProvider>
            <LevelsProvider>
              <RulesProvider>
                <RewardsProvider>
                  <Page>
                    <PageHeader>
                      <TopBar />
                      <LoyaltyTopbar />
                    </PageHeader>
                    <PageBody>
                      <QlfPageErrorBoundary>
                        <Outlet />
                      </QlfPageErrorBoundary>
                    </PageBody>
                  </Page>
                </RewardsProvider>
              </RulesProvider>
            </LevelsProvider>
          </LevelConfigProvider>
        </CurrenciesProvider>
      </ReferralConfigProvider>
    </ProgramProvider>
  );
}

function Home() {
  const { program } = useProgram();
  return (
    <Navigate replace={true} to={`/accounts/${program.accountId}/programs/${program.id}/editor`} />
  );
}
